export default {
	"evo-biosafe": "生物安全",
	"install.evo-biosafe": "完成养猪场人员、车辆、消毒等生物安全管理业务应用",
	"module.evo-biosafe": "生物安全业务服务",
	"module.evo-biosafe.desc": "生物安全业务服务",
	"appmodule_custom_biosafe":"生物安全",
	"EVOBIOSAFE_001":"生物安全",
	"EVOBIOSAFE_001001":"预约审批",
    "EVOBIOSAFE_001001001":"审批记录",
    "EVOBIOSAFE_001001001001":"查看",
    "EVOBIOSAFE_001001001002":"批量审批",
    "EVOBIOSAFE_001001001003":"申请",

    "EVOBIOSAFE_001001002":"访客来访记录",
    "EVOBIOSAFE_001001002001":"查看",
    "EVOBIOSAFE_001001002002":"导出",

    "EVOBIOSAFE_001001003":"刷卡记录",
    "EVOBIOSAFE_001001003001":"查看",
    "EVOBIOSAFE_001001003002":"导出",

    "EVOBIOSAFE_001002":"人员采样管理",
    "EVOBIOSAFE_001002001":"查看",
    "EVOBIOSAFE_001002002":"批量采样",
    "EVOBIOSAFE_001002003":"批量下发",
    "EVOBIOSAFE_001002004":"批量清离",

    "EVOBIOSAFE_001003":"环境管理",
    "EVOBIOSAFE_001003001":"环境消毒",

    "EVOBIOSAFE_001003001001":"场外人员隔离点消毒",
    "EVOBIOSAFE_001003001001001":"查看",
    "EVOBIOSAFE_001003001001002":"添加",
    "EVOBIOSAFE_001003001001003":"删除",

    "EVOBIOSAFE_001003001002":"物资中转站每日消毒",
    "EVOBIOSAFE_001003001002001":"查看",
    "EVOBIOSAFE_001003001002002":"添加",
    "EVOBIOSAFE_001003001002003":"删除",

    "EVOBIOSAFE_001003001003":"出猪台洗消",
    "EVOBIOSAFE_001003001003001":"查看",
    "EVOBIOSAFE_001003001003002":"添加",
    "EVOBIOSAFE_001003001003003":"删除",
    
    "EVOBIOSAFE_001003001004":"卸猪台洗消",
    "EVOBIOSAFE_001003001004001":"查看",
    "EVOBIOSAFE_001003001004002":"添加",
    "EVOBIOSAFE_001003001004003":"删除",

    "EVOBIOSAFE_001003002":"环境采样",
    "EVOBIOSAFE_001003002001":"物资中转站环境采样",
    "EVOBIOSAFE_001003002001001":"查看",
    "EVOBIOSAFE_001003002001002":"添加",
    "EVOBIOSAFE_001003002001003":"删除",

    "EVOBIOSAFE_001003002002":"出猪台采样",
    "EVOBIOSAFE_001003002002001":"查看",
    "EVOBIOSAFE_001003002002002":"添加",
    "EVOBIOSAFE_001003002002003":"删除",

    "EVOBIOSAFE_001003002003":"卸猪台采样",
    "EVOBIOSAFE_001003002003001":"查看",
    "EVOBIOSAFE_001003002003002":"添加",
    "EVOBIOSAFE_001003002003003":"删除",

    "EVOBIOSAFE_001003003":"巡查记录",
    "EVOBIOSAFE_001003003001":"查看",
    "EVOBIOSAFE_001003003002":"添加",
    "EVOBIOSAFE_001003003003":"删除",

    "EVOBIOSAFE_001003004":"设备巡检",
    "EVOBIOSAFE_001003004001":"查看",
    "EVOBIOSAFE_001003004002":"添加",
    "EVOBIOSAFE_001003004003":"删除",
    
    "EVOBIOSAFE_001003005":"周边调查",
    "EVOBIOSAFE_001003005001":"查看",
    "EVOBIOSAFE_001003005002":"添加",
    "EVOBIOSAFE_001003005003":"删除",

    "EVOBIOSAFE_001004":"车辆管理",
    "EVOBIOSAFE_001004001":"车辆状态信息",

    "EVOBIOSAFE_001004002":"车载设备检测",
    "EVOBIOSAFE_001004002001":"查看",
    "EVOBIOSAFE_001004002002":"添加",
    "EVOBIOSAFE_001004002003":"删除",

    "EVOBIOSAFE_001004003":"车辆行驶记录",
    "EVOBIOSAFE_001004004":"人员中转车洗消记录",
    "EVOBIOSAFE_001004005":"人员中转车周2次洗消采样",
    "EVOBIOSAFE_001004006":"车辆洗检查记录",
    "EVOBIOSAFE_001004007":"车辆洗消毒检查记录",
    "EVOBIOSAFE_001004008":"靠场车辆检查消毒",
    "EVOBIOSAFE_001004009":"场外粪肥中转车登记",
    "EVOBIOSAFE_001004010":"车打料采样登记",
    "EVOBIOSAFE_001005":"物资管理",
// 物资管理tab 总菜单
    "EVOBIOSAFE_001005001":"中转站物资",
    "EVOBIOSAFE_001005001001":"中转站物资采样",
    "EVOBIOSAFE_001005001002":"中转站物资登记",
    "EVOBIOSAFE_001005001003":"中转站物资消毒",
    "EVOBIOSAFE_001005002":"食材物资",
    "EVOBIOSAFE_001005002002":"食材物资登记",
    "EVOBIOSAFE_001005002001":"食材物资采样",
    "EVOBIOSAFE_001005003":"非中转物资",
    // "EVOBIOSAFE_001005005":"非中转物资厂家装货登记",
    // "EVOBIOSAFE_001005006":"非中转物资登记",
    "EVOBIOSAFE_001006":"字典维护",
    "EVOBIOSAFE_001007":"可视大屏",
    "EVOBIOSAFE_001008":"信息中心",
    "EVOBIOSAFE_001008001":"消息公告",
    "EVOBIOSAFE_001008002":"短信模板",
    "EVOBIOSAFE_001008003":"SOP业务报警信息",
    "EVOBIOSAFE_001009":"我的任务",
    "EVOBIOSAFE_001009001":"规则配置",
    "EVOBIOSAFE_001009002":"创建任务",
    "EVOBIOSAFE_001009003":"待办任务",
    "EVOBIOSAFE_001009004":"历史任务",

    'common.personidentity': '人员身份',
    'biosafe.formName1': '出猪台采样表',
    'biosafe.formName2': '场外人员隔离点每日消毒表',
    'biosafe.formName3': '物资中转站每日消毒表',
    'biosafe.formName4': '人员采样登记表',
    'biosafe.formName5': '场外物资中转站每周2次洗消采样表',
    'biosafe.formName6': '日常巡场情况登记表',
    'biosafe.formName7': '摄像头检查登记表',
    'biosafe.formName8': '猪场周边3公里养猪户调研情况表',
    'biosafe.formName9': '物资中转站物资登记表',
    'biosafe.formName10': '食材登记表',
    'biosafe.formName11': '非中转物资厂家装货登记表',
    'biosafe.formName12': '非中转物资登记表',
    'biosafe.formName13': '物资采样单',

    'biosafe.formName14': '食材采样单',
    'biosafe.formName15': '出猪每日采样单',
    'biosafe.formName16': '卸猪每日采样单',
    'biosafe.formName17': '出猪每日洗消单',
    'biosafe.formName18': '卸猪每日洗消单',
    'biosafe.car.formName1':'车辆GPS/行车记录仪检查登记表',

    'biosafe.searchHolder': '模糊搜索',
    'biosafe.taskType': '任务类型',
    'biosafe.formType': '表单',
    'biosafe.operatorName': '通知人员',
    'biosafe.notify.role': '通知角色',
    'biosafe.operator': '操作人员',
    'biosafe.operatTime': '操作时间',
    'biosafe.formList': '备选表单',
    'biosafe.chooseForms': '已选表单({0})',
    'biosafe.checkAll': '全选',
    'biosafe.taskCode': '任务编号',
    'biosafe.taskForms': '任务单',
    'biosafe.operatorOrCar': '车辆&人员',
    'biosafe.taskTimes': '任务时间',
    'biosafe.belongTask': '所属任务',
    'biosafe.dateTxt1': '今天',
    'biosafe.dateTxt2': '本周',
    'biosafe.dateTxt3': '本月',
    'biosafe.taskStatus': '全部,已填,未填,超期',
    'biosafe.titleTxt1': '选择表单-人员',
    'biosafe.titleTxt2': '选择车辆-人员',
    'biosafe.tabName1': '按部门人员',
    'biosafe.tabName2': '按角色',
    'biosafe.msgTip1': '请选择任务',
    'biosafe.msgTip2': '请选择人员或角色',
    'biosafe.msgTip3': '请输入人员名称',
    'biosafe.msgTip4': '请输入角色名称',
    'biosafe.msgTip5': '请选择人员',
    // 环境管理
    'biosafe.tabTittle1': '场外人员隔离点消毒',
    'biosafe.tabTittle2': '物资中转站每日消毒',
    'biosafe.tabTittle3': '场外人员隔离点采样',
    'biosafe.tabTittle4': '物资中转站每日采样',
    'biosafe.tabTittle5': '人车每日采样',
    'biosafe.tabTittle6': '出猪台每日采样',
    'biosafe.tabTittle7': '卸猪台每日采样',
    'biosafe.tabTittle8': '出猪台洗消',
    'biosafe.tabTittle9': '卸猪台洗消',
    'biosafe.holdTip1': '消毒人姓名/工号/地点',
    'biosafe.holdTip2': '操作人员姓名',
    'biosafe.holdTip3': '检查人员姓名/工号',
    'biosafe.holdTip4': '检查人员姓名/监控点',
    'biosafe.holdTip5': '姓名/工号/养猪户/乡镇/村落',
    'biosafe.holdTip6': '操作人员编号',
    'biosafe.holdTip7': '物资批次/操作人姓名/编号',
    'biosafe.holdTip8': '食材批次/操作人姓名/编号',
    'biosafe.holdTip9': '货源公司/操作人姓名/编号',
    'biosafe.holdTip10': '物资批次/采样人员',
    'biosafe.holdTip13': '采样人员',
    'biosafe.holdTip11': '模板编号/模板名称',
    'biosafe.disin1': '消毒单号',
    'biosafe.disin2': '消毒人员',
    'biosafe.disin3': '消毒方式',
    'biosafe.disin4': '消毒剂类型',
    'biosafe.disin5': '消毒开始时间',
    'biosafe.disin6': '消毒结束时间',
    'biosafe.disin7': '消毒照片',
    'biosafe.disin8': '所属猪场',
    'biosafe.disin9': '消毒地点',
    'biosafe.disin10': '消毒人姓名',
    'biosafe.disin11': '消毒人工号',
    'biosafe.disin12': '消毒比例',
    'biosafe.disin13': '车辆类型',
    "biosafe.disin14": "类型",
    'biosafe.outSupp1': '表单号',
    'biosafe.disinTime': '消毒时间',
    'biosafe.checkDate': '检查日期',
    'biosafe.chedkTime': '检查时段',
    'biosafe.chedkTimeS': '开始检查时段',
    'biosafe.chedkTimeE': '结束检查时段',
    'biosafe.checkEvt': '异常事件/问题',
    'biosafe.checkPerson': '检查人员',
    'biosafe.checkPic': '问题图片',
    'biosafe.checkStatue': '处置状态',
    'biosafe.checkArea': '检查区域',
    'biosafe.cameraUnusual': '异常监控点位名称',
    'biosafe.cameraShot': '监控截图',
    'biosafe.checkContentDate': '检查内容日期',
    'biosafe.surveyDate': '调查日期',
    'biosafe.surveyFarmerName': '养猪户名称',
    'biosafe.surveyTownName': '乡镇',
    'biosafe.surveyVillage': '村落',
    'biosafe.surveyDistance': '距离(KM)',
    'biosafe.surveySowNum': '母猪(头)',
    'biosafe.surveyBoarNum': '种公猪(头)',
    'biosafe.surveyPigletNum': '育肥猪/仔猪(头)',
    'biosafe.surveySumNum': '合计(头)',
    'biosafe.surveyPigsHealth': '猪群健康状况',
    'biosafe.health': '健康',
    'biosafe.notHealth': '不健康',
    'biosafe.betterHealth': '较健康',
    'biosafe.surveyIsClear': '是否清除',
    'biosafe.IsClear': '确认',
    'biosafe.notClear': '不确认',
    'biosafe.surveyOperatorCode': '操作人编号',

    // 人员采样管理
    'biosafe.batch': '批次编号',
    'biosafe.samp': '采样',
    'biosafe.samp2': '二次采样',

    'biosafe.sampMutip': '批量采样',
    'biosafe.issuedMutip': '批量下发',
    'biosafe.clearMutip': '批量清离',
    'biosafe.sampSingle': '单个采样',
    'biosafe.sampTip1': '请选择要采样的人员',
    'biosafe.sampTip2': '请选择要下发权限的人员',
    'biosafe.sampTip3': '请选择未采样的人员',
    'biosafe.sampTip4': '请选择已采样的人员',
    'biosafe.sampTip5': '请选择采样结果为阴性的人员',
    'biosafe.sampTip6': '请选择未下发权限的人员',
    'biosafe.sampTip7': '请选择需要清离的人员',
    'biosafe.sampTip8': '请选择未下发权限且未清离的人员',
    'biosafe.sampTime': '采样时间',
    'biosafe.sampResult': '采样结果',
    'biosafe.sampResult0': '阴性',
    'biosafe.sampResult1': '阳性',
    'biosafe.sampResult2': '未知',
    'biosafe.sampResultDic': '阴性,阳性,未知',
    'biosafe.enumStatDic': '启用,不启用',
    'biosafe.enumClearDic': '全部,是,否',
    'biosafe.enumClearSelDic': '是,否',
    'biosafe.enumClearSklDic': '--,出猪前采样,出猪后采样',
    'biosafe.enumClearOutSklDic': '--,出猪前洗消,出猪后洗消',
    'biosafe.enumOutPigeDic': '--,卸猪前采样,卸猪后采样',
    'biosafe.enumClearHealthDic': '健康,较健康,不健康',
    'biosafe.ClearHealthDic': '确认,不确认',
    'biosafe.enumSampStatueDic': '未采样,已下发,已清离',
    'biosafe.identityDic': '访客,休班人员,离场人员,返场人员',
    'biosafe.sexDic': '男,女',
    'biosafe.sampResultTip1': '采样成功',
    'biosafe.sampResultTip2': '采样失败',
    'biosafe.sampResultTip3': '批量权限下发成功',
    'biosafe.sampResultTip4': '批量权限下发失败',
    'biosafe.sampResultTip5': '批量清离成功',

    // 字典维护
    'biosafe.enumType': '字典类型',
    'biosafe.enumName': '字典名称',
    'biosafe.enumDescription': '字典描述',
    'biosafe.enumStat': '是否启用',
    'biosafe.deleteTitle': '删除字典类型',
    'biosafe.deleteTip1': '请选择要删除的项',
    'biosafe.deleteTip2': '删除数据不可恢复，是否确定删除？',
    'biosafe.deleteTip3': '确认要删除该条数据吗？',
    'biosafe.deleteTip4': '删除类型成功',
    'biosafe.deleteSTip': '删除成功',
    'biosafe.deleteETip': '删除失败',
    'biosafe.ajaxTip1': '新增字典类型成功',
    'biosafe.ajaxTip2': '更新字典类型成功',
    'biosafe.ajaxTip3': '新增字典类型失败',
    'biosafe.ajaxTip4': '更新字典类型失败',
    'biosafe.ajaxTip5': '删除字典类型成功',
    'biosafe.ajaxTip6': '删除字典类型失败',
    'biosafe.enum_type1': '车辆用途',

    // 物资管理
    'biosafe.suppliesBatch': '物资批次',
    'biosafe.suppliesSum': '物资总数',
    'biosafe.suppliesRegDate': '登记日期',
    'biosafe.suppliesUseArea': '使用区域',
    'biosafe.suppliesIsBox': '能否装箱',
    'biosafe.suppliesCKList': '物资清单',
    'biosafe.suppliesName': '物资名称',
    'biosafe.suppliesNum': '物资数量',
    'biosafe.suppFoodBatch': '食材批次',
    'biosafe.suppFoodSum': '食材总数',
    'biosafe.suppSupplyName': '货源公司名称',
    'biosafe.suppSupplyAddr': '货源地址',
    'biosafe.suppSupplyTime': '装货日期时间',
    'biosafe.suppEnterTime': '录入时间',
    'biosafe.suppEnterSDate': '考场时间日期',
    'biosafe.sampPerson': '采样人员',
    'biosafe.suppliesEmpty': '物资清单为空',
    'biosafe.suppliesSampQualified': '是否采样合格',
    'biosafe.suppliesEnterDate': '靠场日期',
    'biosafe.suppliesBatchNum': '物资批号',

    // 消息中心
    'biosafe.inforTempCode': '模板编号',
    'biosafe.inforTempName': '模板名称',
    'biosafe.inforTempContent': '模板内容',
	
	//生物安全
    'biosafe.appointment':"访客预约",
    'biosafe.off-duty':"休班离场",
    'biosafe.duty-return':'休班返场',
    'biosafe.enum_type':'姓名/身份证号/联系电话',
    // 表格上方操作按钮
    'biosafe.batchapproval': '批量审批',
    'biosafe.approval': '申请',
    'biosafe.enum_search': '模糊搜索',
    'biosafe.user-placeholder': '请输入',
    // 生物安全审批记录表格头部
    'biosafe.table.personName': "姓名",
    'biosafe.table.sex': "性别",
    'biosafe.table.phone': "联系方式",
    'biosafe.table.paperNumber': "身份证号",
    'biosafe.table.origin': "出发地",
    'biosafe.table.arriveTime': "到达日期",
    'biosafe.table.reason': "来访原因",
    'biosafe.table.lastTouchPigTime': "上次接触猪日期",
    'biosafe.table.isTouchRiskPlace': "是否出入高风险场所",
    'biosafe.table.status': "审批结果",
    'biosafe.table.approval': "审核",
    // 弹出表单详情字段
    'biosafe.table.trafficMode': "交通方式",
    'biosafe.table.clothSize': "穿衣尺寸",
    'biosafe.table.visitorName': "姓名",
    // 审批弹框
    'biosafe.table.formModal': "预约审批",
    'biosafe.table.approvalResults': "审批结果",
    'biosafe.table.opinion': "审批意见",
    'biosafe.table.approvalModal': "审批",
    'biosafe.table.approvalModalShow': "审批查看",
    // 来访记录弹框
    'biosafe.table.domainId': "猪场名称",
    'biosafe.table.deviceName': "设备名称",
    // 查看详情弹框
    'biosafe.table.cardRecord': '访客刷卡记录',
    'biosafe.table.visitorRecord': '访客来访记录',
    'biosafe.table.departmentName': '部门',
    'biosafe.table.checkInTime': '签入时间',
    'biosafe.table.checkOutTime': '签出时间',
    // 生物安全访客来访记录表格头部
    'biosafe.table.visitorPaperNumber': "证件号",
    'biosafe.table.visitorPhoneNum': "联系电话",
    'biosafe.table.vStartTimeStr': "预约来访时间",
    'biosafe.table.rvStartTimeStr': "实际来访时间",
    'biosafe.table.rvEndTimeStr': "签离时间",
    'biosafe.table.vStatus': "状态",
    // 生物安全访客刷卡记录表格头部
    'biosafe.table.swingTime': "时间",
    'biosafe.table.vCardStatus': "卡状态",
    'biosafe.table.channelName': "门通道名称",
    'biosafe.table.openType': "开门类型",
    'biosafe.table.openResult': "开门结果",
    'biosafe.table.enterOrExit': "事件类型",
    'biosafe.table.errorCode': "失败原因",
    'biosafe.table.peopleType': "全部,内部人员,访客",

    // 休班离场表格
    'biosafe.table.personCode': "人员编号",
    'biosafe.table.personDept': "人员部门",
    'biosafe.table.visitorPhoneNum': "人员电话",
    'biosafe.table.createTime': "申请时间",
    'biosafe.table.leaveTime': "离场时间",
    'biosafe.table.updateTime': "预计返场时间",
    'biosafe.table.offReason': "申请原因",
    // 休班返场表格
    'biosafe.table.luggage': "携带物品",
    'biosafe.table.lastTouchRiskPlaceTime': "上次接触高风险场所日期",
    'biosafe.table.paperType': "身份证类型",
    'biosafe.table.shoeSize': "鞋子大小",
    'biosafe.table.isTouchPig': "是否接触猪",
    //  访客来访记录下拉框toggle模糊查询表单
    'biosafe.table.vinBox': "签入岗亭",
    'biosafe.table.vOutBox': "签出岗亭",
    //  访客刷卡记录下拉框toggle模糊查询表单
    'biosafe.table.openTime': "开门时段",
    'biosafe.table.cardNumber': "卡号",
    'biosafe.table.domainName': "猪场名称",
    // 接口返回的错误提示
    'error60120002': '人员不能进行授权',
    'error60120004': '人员已经批量处理',
    'error99020023': '空指针异常',

    // 卡类型
    'biosafe.BLANK': '空白',
    'biosafe.ACTIVE': '正常',
    'biosafe.FROZEN': '挂失',
    'biosafe.WITHDRAWN': '注销',
    // 是否+事件+开门结果
    'biosafe.table.isOrNot': '是,否',
    'biosafe.table.enterOrExitType': '全部,进门,出门,进/出门',
    'biosafe.table.openResultType': '全部,成功,失败',
    // 车辆管理
    'biosafe.carNumber':'车牌号',
    'biosafe.carType':'车牌类型',
    'biosafe.carColor':'车辆颜色',
    'biosafe.RegTime':'登记时间',
    'biosafe.GPS':'设备名称',
    'biosafe.checkDate':'检查日期',
    'biosafe.checkConDate':'检查内容日期',
    'biosafe.dockEvent':'异常停靠/事件记录',
    'biosafe.monitor':'监测人',
    'biosafe.trackEvent':'轨迹/事件截图',
    'biosafe.recordTime':'记录时间',
    'biosafe.recordPoint':'记录点位',
    'biosafe.inspectors':'检查人',
    'biosafe.disposStatus':'处置状态',
    'biosafe.recordDate':'记录日期',
    'biosafe.cleanDis':'洗消人员',
    'biosafe.cleanDisDate':'洗消人员',
    'biosafe.cleanDisDur':'洗消时长',
    'biosafe.dryNot':'是否烘干',
    'biosafe.Abnormal':'是否异常',
    'biosafe.washPlace':'洗消地点',
    'biosafe.driver':'司机名称',
    'biosafe.sCleantime':'开始清洗时间',
    'biosafe.eCleantime':'结束清洗时间',
    'biosafe.cleanQua':'车辆清洗质量检查',
    'biosafe.onSite':'靠场日期',
    'biosafe.onSiteReason':'靠场原因',
    'biosafe.carOutIsClean':'车辆外观检查是否干净',
    'biosafe.taskNumber':'任务单号',

    // 表单title
    'biosafe.cleanDisTitle':'场外人员中转车辆消毒表',
    'biosafe.carCheckTitle':'车辆1洗质量检查登记表',
    'biosafe.carCleanDisTitle':'车辆清洗消毒检查登记表',
    'biosafe.carOnsiteTitle':'靠场车辆检查消毒表',
    'biosafe.materialSampTitle':'打料采样单',
    'biosafe.manTran':'场外粪肥中转车装粪肥信息登记表',
    'biosafe.noSel':'请选择一条记录',

    'car.outside':'外部车辆',
    'car.inner':'内部车辆'
}